import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    changeExtensionDetails: (oldExt: string, newExt: string) => string | React.ReactNode;
    changeToExtension: string;
    keepOldExtension: string;
};
export type Deps = {
    Text: any;
    theme: any;
    WARNING_PADDING_BOTTOM: any;
    WARNING_PADDING_TOP: any;
};
export default {
    DEFINE(_messages: Text, { Text, theme, WARNING_PADDING_BOTTOM, WARNING_PADDING_TOP }: Deps): void {
        return Object.defineProperties(this, {
            changeExtensionDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (oldExt: string, newExt: string) => __intl__.intl().formatMessage({ id: "RenameWarningDialog.changeExtensionDetails?c=1z3nhqmc0llzq", defaultMessage: "<jsx><Text>Are you sure you want to change the file extension from \"{oldExt}\" to \"{newExt}\"?</Text> <Text1>Your file type will remain unchanged.</Text1></jsx>" }, { jsx: (__children__: React.ReactNode) => React.Children.toArray(__children__), Text: (__children__: React.ReactNode) => <Text>{React.Children.toArray(__children__)}</Text>, oldExt: oldExt, newExt: newExt, Text1: (__children__: React.ReactNode) => <Text style={{ paddingBottom: theme.spaces[WARNING_PADDING_BOTTOM], paddingTop: theme.spaces[WARNING_PADDING_TOP] }} variant="secondary">{React.Children.toArray(__children__)}</Text> }));
                },
                enumerable: true,
                configurable: true
            },
            changeToExtension: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "RenameWarningDialog.changeToExtension?c=3lvjn12n0b6w5", defaultMessage: "Change" }));
                },
                enumerable: true,
                configurable: true
            },
            keepOldExtension: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "RenameWarningDialog.keepOldExtension?c=3uil2uygoj7ck", defaultMessage: "Keep" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps: Deps): void;
};
